import React from 'react';
import { Link } from 'react-router-dom';
import techImage from '../img/tech1.jpg';

const LidarServicesPage = () => {
  const services = [
    {
      title: "LiDAR Data Solutions",
      description: "Terrestrial and mobile LiDAR data acquisition and advanced processing for precise spatial data collection and analysis.",
      icon: "📊"
    },
    {
      title: "Geospatial Intelligence & Modeling",
      description: "Expert GIS mapping, robust 2D/3D data modeling, and seamless system integration for comprehensive spatial analysis.",
      icon: "🗺️"
    },
    {
      title: "Aerial Data Collection",
      description: "Drone/UAV-based aerial imagery collection for diverse applications, providing high-resolution data from above.",
      icon: "🚁"
    },
    {
      title: "Subsurface Analysis",
      description: "Ground Penetrating Radar (GPR) data handling and interpretation for detailed subsurface insights.",
      icon: "🔍"
    },
    {
      title: "Immersive Visuals",
      description: "360° street view imaging services for comprehensive spatial visualization and virtual tours.",
      icon: "🔄"
    }
  ];

  return (
    <div className="min-h-screen bg-figma-dark-bg-primary text-figma-dark-text-primary">
      {/* Hero Section */}
      <section 
        className="relative min-h-[60vh] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: `url(${techImage})` }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center px-4 py-16">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
            <span className="bg-gradient-to-r from-figma-dark-primary to-figma-dark-accent bg-clip-text text-transparent">
              LiDAR & Geospatial Solutions
            </span>
          </h1>
          <p className="text-xl text-figma-dark-text-secondary max-w-3xl mx-auto">
            Advanced spatial data solutions for precise mapping, modeling, and analysis
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 px-4 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-figma-dark-bg-secondary/30 backdrop-blur-sm border border-figma-dark-border rounded-xl p-6 hover:shadow-figma-dark-glow transition-all duration-300"
            >
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-3 text-white">{service.title}</h3>
              <p className="text-figma-dark-text-secondary">{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-figma-dark-bg-secondary/20">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6 text-white">Ready to Transform Your Spatial Data?</h2>
          <p className="text-figma-dark-text-secondary mb-8">
            Let's discuss how our LiDAR and geospatial solutions can enhance your projects
          </p>
          <Link
            to="/contact"
            className="px-8 py-4 rounded-full bg-gradient-to-r from-figma-dark-primary to-figma-dark-accent text-white font-medium hover:shadow-figma-dark-glow transition-all duration-300 hover:scale-105"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default LidarServicesPage; 